import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  BrineCalculationRequestDto,
  BrineCalculationResultDto,
  BrineFormulationDto,
  BrineTypeDto,
  SaveBrineFormulationDto,
} from '@models/brine-formulation-dto.interface';

@Injectable({ providedIn: 'root' })
export class BrineFormulationService {
  private readonly api = inject(ApiService);

  getBrineTypes(): Observable<BrineTypeDto[]> {
    return this.api.get('brine-types');
  }

  calculate(dto: BrineCalculationRequestDto): Observable<BrineCalculationResultDto> {
    return this.api.post('brine-formulations/calculate', dto as unknown as object);
  }

  getByJobRequest(jobRequestId: number): Observable<BrineFormulationDto> {
    return this.api.get(`brine-formulations/job-requests/${jobRequestId}`);
  }

  save(jobRequestId: number, dto: SaveBrineFormulationDto): Observable<BrineFormulationDto> {
    return this.api.put(`brine-formulations/job-requests/${jobRequestId}`, dto as unknown as object);
  }
}
